<template>
  <div class="event" @click="loadEvent(id)">
    <h3>{{ title }}</h3>
    <i
      >{{ startDate.toLocaleString() }} -
      {{
        startDate.getDate() === endDate.getDate()
          ? endDate.toLocaleTimeString()
          : endDate.toLocaleString()
      }}</i
    >
    <p>{{ description }}</p>
    <button>View details</button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "HomeEvent",
  props: {
    title: { type: String as PropType<string>, required: true },
    startDate: { type: Date as PropType<Date>, required: true },
    endDate: { type: Date as PropType<Date>, required: true },
    description: { type: String as PropType<string>, required: true },
    location: { type: String as PropType<string>, required: true },
    id: { type: String as PropType<string>, required: true },
  },
  methods: {
    loadEvent(id: string) {
      window.location.href = `/event/${id}`;
    },
  },
});
</script>

<style>
.event {
  width: 80vw;
  border: 2px var(--text) solid;
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 5px;
  padding-left: 15px;
}

.event > h3,
.event > i,
.event > p {
  margin: 4px;
}

.event > button {
  width: 97%;
  border-radius: 5px;
  background-color: var(--secondary);
  margin-bottom: 10px;
}
</style>
